// B3-05: one consolidated, scannable list of everything the person is browsing
// that belongs to the Professional plan, always reachable from the explore
// banner.

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const PROFESSIONAL_ONLY_LIST: Array<{ name: string; detail: string }> = [
  { name: "Live ratio compliance", detail: "Every room checked against its statutory ratio, updated as staff and children sign in." },
  { name: "Ofsted readiness score", detail: "A live score across all nine inspection categories, with the reasons behind it." },
  { name: "Ofsted audit pack export", detail: "One click produces the full pack: registers, ratios, certificates, policies and safeguarding logs." },
  { name: "Risk assessments", detail: "Digital forms, staff completion, manager sign-off and a full history." },
  { name: "Safeguarding records", detail: "Accident, incident and behaviour log, complaints log, and confidential LADO records." },
  { name: "Fire safety", detail: "Termly drills, equipment servicing dates and fire documents in one place." },
  { name: "Attendance and funding", detail: "Weekly and monthly attendance, funded hours tracking and claim-ready exports." },
  { name: "Additional day requests", detail: "Parents request extra days, you approve, and the register updates itself." },
  { name: "Pickups and drop-offs", detail: "School runs, bookings and three-stage tracking for every child." },
  { name: "Reports and audit log", detail: "Rota hours, occupancy, payroll-ready exports and a complete record of every action." },
  { name: "Alerts and reminders", detail: "Automatic DBS, First Aid, ratio and absence alerts before they become problems." },
  { name: "Unlimited children and staff", detail: "Starter covers up to 25 children. Professional has no cap." },
];

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ProfessionalOnlyDialog({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display">What is Professional-only?</DialogTitle>
          <DialogDescription className="text-left">
            You can look around all of this in the sample nursery. On your own nursery,
            these sections come with the Professional plan.
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-3">
          {PROFESSIONAL_ONLY_LIST.map((item) => (
            <li key={item.name} className="flex gap-2">
              <span aria-hidden className="mt-0.5 text-[#92400E]">✦</span>
              <div>
                <p className="text-sm font-medium font-body text-nursly-ink">{item.name}</p>
                <p className="text-[13px] font-body text-nursly-muted">{item.detail}</p>
              </div>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
